<template>
  <div class="invite__content">
    <div v-show="resolved" class="invite__success-content">
      <LargeNotice :title="$t('invite.success-title')" :subtitle="$t('invite.success-subtitle')" success />
      <div class="invite__note">
        {{ $t('forgot-password.success-hint') }}
        <span class="no-reply-email">
          {{ $t('forgot-password.noreply-email') }}
        </span>
        {{ $t('forgot-password.success-hint-second-part') }}

        <BaseButton class="invite__note__contact-us" @click.native="contactUs" is-small is-secondary>
          {{ $t('navigation-bar.beacon') }}
        </BaseButton>
      </div>
    </div>
    <InviteForm v-show="!resolved" @submit="submitForm" class="invite__form" />
  </div>
</template>

<script>
import BaseButton from '@/components/base/BaseButton';
import { Beacon } from '@/plugins/beacon';
import InviteForm from '@/components/page-invite/InviteForm';
import LargeNotice from '@/components/notice/LargeNotice';

import { mapGetters, mapActions } from 'vuex';

export default {
  components: {
    BaseButton,
    LargeNotice,
    InviteForm,
  },
  props: {
    invitePreview: Object,
    token: String,
  },
  computed: {
    ...mapGetters('acceptInvite', ['resolved']),
  },
  methods: {
    ...mapActions('acceptInvite', ['acceptInvite']),
    submitForm(userTemp) {
      const user = { ...userTemp, tenantId: this.invitePreview.tenantId, email: this.invitePreview.email };
      this.acceptInvite({ token: this.token, user: user })
        .then(() => this.$toast.success(this.$t('toast.success')))
        .catch((e) => {
          this.$toast.error(e);
        });
    },
    contactUs() {
      Beacon.toggle();
      Beacon.navigate('ask');
    },
  },
};
</script>

<style lang="scss">
.invite {
  &__content {
    height: 100%;
    width: 100%;
    display: flex;
  }

  &__success-content {
    max-width: 600px;
    justify-content: center;
    margin: auto;
  }

  &__form {
    max-width: 600px;
    padding-bottom: 32px;
    width: 100%;
    justify-content: center;
    margin: auto;
  }

  &__note {
    color: $color-normal-pale;
    font-family: $font-family-raleway;
    font-size: $font-size-small;
    font-stretch: normal;
    font-style: normal;
    font-weight: normal;
    letter-spacing: normal;
    line-height: 1.83;
    text-align: center;
    padding-top: 32px;

    &__contact-us {
      display: block;
      margin-top: 15px;
    }
  }
}
</style>
